<template>
    <div>
        <Content :style="{padding: '24px', minHeight: '480px', background: '#fff'}">
            <el-form ref="queryParams" inline label-position="right" label-width="80px" v-model="queryParams">
                <el-form-item label="仓库选择" prop="warehouseId">
                    <el-select size="small"  v-model="queryParams.warehouseId" @change="search()" style="width: 160px"  :clearable="true" placeholder="支持搜索">
                        <el-option v-for="(option, index) in warehouses" :value="option.id" :key="index" :label="option.name">{{option.name}}
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="规格属性">
                    <el-input size="small" v-model="queryParams.productId" @keyup.enter.native="search()" placeholder="请输入规格属性" style="width: 160px" />
                </el-form-item>
                 <el-form-item label="sku编码">
                    <el-input size="small" v-model="queryParams.productId" @keyup.enter.native="search()" placeholder="请输入sku编码" style="width: 160px" />
                </el-form-item>
                <el-form-item label="商品名">
                    <el-input size="small" v-model="queryParams.name" @keyup.enter.native="search()" placeholder="商品名" style="width: 160px" />
                </el-form-item>
                <el-form-item label="商户号">
                    <el-input size="small" v-model="queryParams.userId" @keyup.enter.native="search()" placeholder="请输入商户号" type="number" style="width: 160px" />
                </el-form-item>
                <el-form-item>
                    <el-button size="small" v-on:click="search()" type="primary">搜索</el-button>
                    <el-button size="small" v-on:click="reset()">重置</el-button>
                </el-form-item>



            </el-form>
            <div style="margin-bottom: 10px">
                 <el-button size="small" type="warning" @click="setDayin" >
                    <template v-if="!printName">设置打印机</template>
                    <template v-else>已选打印机:{{printName}}</template>
                </el-button>
            </div>
            <Table :loading="loading" :columns="columns" :data="storageProducts" border>
            </Table>
            <div style="margin: 10px;overflow: hidden">
                <div style="float: right;">
                    <Page :page-size="page.pageSize" show-total :total="page.total" :current="page.current" @on-change="changePage"></Page>
                </div>
            </div>
        </Content>
        <CStorageProductChange v-bind:type="moneyChange.type" v-bind:show="modalMoneyEdit" v-bind:productId="moneyChange.productId" v-bind:title="moneyChange.title" v-on:ok="modalMoneyEdit=false;getList();" @cancel="modalMoneyEdit=false;"></CStorageProductChange>
        <CStorageProductChangeList :show="modalChangeListShow" v-bind:productId="moneyChange.productId" v-on:ok="modalChangeListShow=false;" @cancel="modalChangeListShow=false;"></CStorageProductChangeList>
        <CPrintSku ref="refPrintSku" @boxCallBack="boxCallBack" :products="selected"></CPrintSku>

            <CPrintSet :defaultPrinter="printName" :printers="printers" @cancel="printerShow=false" @ok="printSetOk" :show="printerShow"></CPrintSet>

    </div>
</template>
<script>
import CStorageProductChangeList from "./CStorageProductChangeList.vue"
import CStorageProductChange from "./CStorageProductChange.vue"
import CPrintSku from "./CPrintSku.vue"
import { getRand } from "@/utils/random"
import CPrintSet from '../Outgo/CPrintSet.vue'
export default {
    name: 'StorageProduct',
    data() {
        return {

            printerShow: false,
            printers: [],
            printName: "",
            socket: null,


            moneyChange: {
                productId: null
            },
            modalChangeListShow: false,
            modalMoneyEdit: false,
            warehouses: [],
            loading: false,
            queryParams: {

            },
            storageProduct: {

            },
            page: {
                total: 0,
                current: 1,
                pageSize: 10
            },
            storageProducts: [

            ],
            selected: [

            ],
            columns: [{
                    title: '仓库',
                    key: 'warehouseName',
                    width: 120,
                    align: 'center'
                }, {
                    title: '图片',
                    key: 'productName',
                    width: 120,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var btns = [];
                        btns.push(h("img", { style: { width: "100px", height: "100px" }, attrs: { src: row.pics } }));

                        return h("div", { padding: "20px" }, btns);
                    }
                }, {
                    title: '商户名',
                    key: 'userName',
                    width: 130,
                    align: 'center'
                }, {
                    title: '商品名称',
                    key: 'productName',
                    width: 230,
                    align: 'center'
                }, {
                    title: '规格/属性',
                    key: 'variationName',
                    width: 130,
                    align: 'center'
                }, {
                    title: 'sku编码',
                    key: 'skuCode',
                    width: 130,
                    align: 'center'
                },{
                    title: '库存',
                    key: 'stock',
                    width: 130,
                    align: 'center'
                }, {
                    title: '库位码',
                    key: 'productId',
                    width: 230,
                    align: 'center',
                    render: (h, params) => {
                        var row = params.row;
                        var btns = [];

                        if (row.locationId > 0) {
                            btns.push(h("div", {}, row.locationCode));
                        } else {
                            btns.push(h("div", {}, "无"));
                        }
                        return h("div", btns);
                    }
                }, {
                    title: '操作',
                    key: 'state',
                    width: 300,
                    align: 'center',
                    fixed: "left",
                    render: (h, params) => {
                        var row = params.row;
                        var spans = [
                            h("div", "商户号：" + row.userId),
                            h("div", "商户名：" + row.userName)
                        ];
                        var btns = [
                            h("Button", {
                                style: { marginRight: "5px" },
                                props: { size: "small", type: "primary" },
                                on: {
                                    click: () => {

                                        this.moneyChange.productId = row.id;
                                        this.modalChangeListShow = true;

                                    }
                                }
                            }, "库存明细")
                        ];
                        btns.push(h("Button", { style: { marginRight: "5px" }, props: { type: "error", size: "small" }, on: { click: () => { this.userMoney("【" + row.productId + "】入库", row, 2); } } }, "入库"));
                        btns.push(h("Button", { style: { marginRight: "5px" }, props: { type: "error", size: "small" }, on: { click: () => { this.userMoney("【" + row.productId + "】出库", row, 1); } } }, "出库"));


                        btns.push(h("Button", {
                            style: { marginRight: "5px" },
                            props: { size: "small", type: "success" },
                            on: {
                                click: () => {
                                    this.storageProduct = row;
                                    this.selected = [row];
                                    this.$refs['refPrintSku'].showDialog();
                                }
                            }
                        }, "打印条码"));
                        return h("div", [h("div", spans), h("div", btns)]);
                    }
                }

            ]
        };
    },
    mounted: function() {
        this.getList();
        this.remoteMethod1();
        this.initPrint();
    },
    components: {
        CPrintSku,
        CPrintSet,
        CStorageProductChange,
        CStorageProductChangeList
    },
    methods: {

        doConnect: function(callback) {
            let serviceUrl = "ws://localhost:13528";
            var me = this;
            me.socket = new WebSocket(serviceUrl);

            // 监听消息
            me.socket.onmessage = function(event) {
                console.log('Client received a message', event);

                let data = JSON.parse(event.data);

                if (data.cmd == "getPrinters") {

                    if (!me.printName) {
                        me.printName = data.defaultPrinter;
                        localStorage.setItem("defaultPrinter", me.printName);
                    }
                    me.printers = data.printers;

                } else if (data.cmd == "print") {

                    if (data.msg == "成功") {

                        if (data.hasOwnProperty("previewURL")) {
                            window.open(data['previewURL']);
                        } else {
                            iNotify.player("printOk");
                        }

                    } else {
                        iNotify.player("printError")
                    }
                }

            };

            me.socket.onopen = function(event) {
                if (callback != null) {
                    callback();
                }

            }

            me.socket.onerror = function(error) {
                console.log("Failed to connect CN print at " + serviceUrl, error);

            }

            // 监听Socket的关闭
            me.socket.onclose = function(event) {
                console.log('Client notified socket has closed', event);

            };
        },
        initPrint() {

            if (!this.socket || typeof this.socket == "undefined" || this.socket.readyState == WebSocket.CLOSED) {
                this.doConnect(this.initPrint);
                return;
            }
            if (this.socket && typeof this.socket != "undefined" && this.socket.readyState == 1) {
                this.printName = localStorage.getItem("defaultPrinter");
                this.getPrinters();
            } else {
                this.printName = "";
            }
        },
        getPrinters() {
            this.socket.send(JSON.stringify({
                "cmd": "getPrinters",
                "requestID": getRand(),
                "version": "1.0"
            }));
        },
        setDayin() {
            if (!this.socket || typeof this.socket == "undefined" || this.socket.readyState == WebSocket.CLOSED) {
                //
                this.$message.error("暂未安装打印控件")
                return;
            }
            this.printerShow = true;
        },
        printSetOk: function(name) {
            this.printName = name;
            localStorage.setItem("defaultPrinter", name);
            this.printerShow = false;
        },
        boxCallBack: function(data) {
             let time = new Date().getTime() + getRand();
            let printData = {
                "cmd": "print",
                "version": "1.0",
                "requestId": time,
                "task": {
                    "taskID": "tk" + time,
                    "preview": true,
                    "printer": this.printName,
                    "notifyMode": "allInOne",
                    "previewType": "pdf",
                    "documents": data
                }
            }
            this.socket.send(JSON.stringify(printData))
        },
        userMoney: function(title, row, type) {
            this.moneyChange.title = title;
            this.moneyChange.type = type;
            this.moneyChange.productId = row.id;
            this.modalMoneyEdit = true;
        },
        remoteMethod1: function() {
            var me = this;
            me.$http.post("/ware/warehouse/getall.action", {}).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.warehouses = body.obj;
                }
            }, response => {

            });

        },
        cbtime: function(value) {
            this.others;
        },
        search: function() {
            this.page.current = 1;
            this.page.total = 0;
            this.getList();
        },
        reset: function() {

            this.queryParams = {};
            this.getList();
        },
        changePage(current) {
            this.page.current = current;
            this.getList();
        },
        getList: function() {
            var me = this;
            var params = me.queryParams;
            params.current = me.page.current;
            params.pageSize = me.page.pageSize;
            me.loading = true;
            me.$http.post("/ware/product/getList.action", params).then(response => {
                var body = response;
                if (body.status == 0) {
                    me.page.total = body.obj.totalCount;
                    me.storageProducts = body.obj.list;

                }
                me.loading = false;
            }, response => {
                me.loading = false;
            });
        }




    }
}
</script>
<style scoped>
</style>